export const core = {
  backHome: 'Volver al inicio',
  title: '¡INGRESA!',
  noAccount: '¿No tienes una cuenta?',
  buttonRegister: 'Regístrate ahora',
  email: 'Correo electrónico',
  password: 'Contraseña',
  buttonForgotPassword: '¿Has olvidado tu contraseña?',
  buttonLogin: 'INGRESAR',
  buttonGoogle: 'Google',
  buttonPhone: 'Teléfono',
};
